<template>
  <v-dialog v-model="dialog" max-width="700px" scrollable>
    <template v-slot:activator="{ on }">
      <mf-button id="load-template" data-userflow-id="load-template" text label="Carregar template" v-on:click.native="on.click" />
    </template>
    <v-card>
      <v-card-title>
        <span>Carregar template de e-mail</span>
        <v-spacer />
        <mf-search v-model="search" hide-details placeholder="Buscar template" autofocus />
      </v-card-title>
      <v-card-text>
        <list-builder-templates ref="listBuilderTemplates" :search="search" :selectedTemplate.sync="selectedTemplate" />
      </v-card-text>
      <v-card-actions>
        <mf-action-buttons
          class="pb-1"
          :primary-button="{
            text: 'Carregar',
            action: loadEmailTemplate,
            isDisabled: !selectedTemplate,
            isVisible: true,
            isLoading: loadingTemplate,
          }"
          :secondary-button="{
            text: 'Cancelar',
            action: close,
            isVisible: true,
          }"
        />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { QUERY_FIND_TEMPLATE } from '@/modules/campanhas/campanhas-email/graphql'

export default {
  components: {
    ListBuilderTemplates: () => import('@/modules/campanhas/campanhas-email/views/components/builder-templates/ListBuilderTemplates.vue'),
  },
  data: () => ({
    dialog: false,
    loadingTemplate: false,
    search: '',
    selectedTemplate: null,
    lastConfirmedTemplate: null,
  }),

  watch: {
    dialog(value) {
      if (value) {
        this.selectedTemplate = this.lastConfirmedTemplate
        this.reset()
      }
    },
  },

  methods: {
    async loadEmailTemplate() {
      try {
        this.loadingTemplate = true
        const { data } = await this.$apollo.query({
          query: QUERY_FIND_TEMPLATE,
          variables: {
            _id: this.selectedTemplate._id,
          },
          context: {
            uri: this.$microservicesUrls['campaigns'],
          },
          fetchPolicy: 'no-cache',
        })
        this.loadingTemplate = false
        this.$emit('input', data.emailTemplate)
        this.lastConfirmedTemplate = this.selectedTemplate
        this.dialog = false
      } catch (e) {
        console.warn(e)
        this.$snackbar({ message: 'Falha ao carregar template de e-mail.', snackbarColor: 'error' })
        this.loadingTemplate = false
      }
    },
    close() {
      this.selectedTemplate = this.lastConfirmedTemplate
      this.dialog = false
    },
    reset() {
      this.search = ''
      if (this.$refs.listBuilderTemplates) {
        this.$refs.listBuilderTemplates.refresh()
      }
    },
  },
}
</script>
